import outcome1 from "../assets/images/outcome1.png"
import outcome2 from "../assets/images/outcome2.png"
import outcome3 from "../assets/images/outcome3.png"
import outcome4 from "../assets/images/outcome4.png"
import outcome5 from "../assets/images/outcome5.png"
import outcome6 from "../assets/images/outcome6.png"
import outcome7 from "../assets/images/outcome7.jpg"
import outcome8 from "../assets/images/outcome8.png"
import outcome9 from "../assets/images/outcome9.png"

export const outcomeData = {
  career_consult_page: {
    backgroundImage: outcome1,
    outcome: [
      {
        title: "Разбор запроса от опытного эксперта",
        text: "Вы получите ответы на все вопросы своего карьерного пути, что позволит вам снять напряжение и неопределенность.",
      },
      {
        title: "Четкий план действий",
        text: "Вы узнаете, как сделать свою карьеру успешной и наполненной новыми возможностями.",
      },
      {
        title: "Важные и полезные материалы",
        text: "Вы обретете информацию, которая позволит вам выйти на новый профессиональный уровень.",
      },
    ]
  },
  cv_ready_page: {
    backgroundImage: outcome2,
    outcome: [
      {
        title: "Успешное резюме",
        text: "Доработаем или вместе создадим с нуля резюме, сделаем вас видимым для рекрутеров / HR-специалистов.",
      },
      {
        title: "Входящие предложения от компаний",
        text: "Почувствуете эффект «рабочего резюме», когда компании сами стучатся к вам с вакансиями.",
      },
      {
        title: "Приглашение на интервью",
        text: "Увеличите конверсию откликов в интервью и получите желаемую работу.",
      },
    ]
  },
  search_support_page: {
    backgroundImage: outcome3,
    outcome: [
      {
        title: "Упаковка профиля",
        text: "Доработаем или вместе создадим с нуля резюме, профиль в LinkedIn и конструктор мотивационных писем. Сделаем вас видимым для рекрутеров.",
      },
      {
        title: "Стратегия отклика",
        text: "Определимся с критериями поиска и расставим приоритеты вместе с ментором. Разработаем план действий / дорожную карту. Никаких “слепых” откликов, осознанный точечный поиск, приносящий результат.",
      },
      {
        title: "Вакансии и рефералы",
        text: "Обеспечим вас подходящими вакансиями и найдем рефералов.",
      },
    ]
  },
  probation_support_page: {
    backgroundImage: outcome4,
    outcome: [
      {
        title: "Уверенность в себе",
        text: "Прогоним внутреннего самозванца и взрастим профессионала.",
      },
      {
        title: "Поддержку от новой команды",
        text: "Не просто наладите отношения, а заручитесь поддержкой и уважением коллектива.",
      },
      {
        title: "Достигнутые цели",
        text: "Добьетесь поставленных целей и подтвердите свою компетентность перед руководителем.",
      },
    ]
  },
  vacancies_page: {
    backgroundImage: outcome3,
    outcome: [
      {
        title: "Упаковка профиля",
        text: "Доработаем или вместе создадим с нуля резюме, профиль в LinkedIn и конструктор мотивационных писем. Сделаем вас видимым для рекрутеров.",
      },
      {
        title: "Стратегия отклика",
        text: "Определимся с критериями поиска и расставим приоритеты вместе с ментором. Разработаем план действий / дорожную карту. Никаких «слепых» откликов, осознанный точечный поиск, приносящий результат.",
      },
      {
        title: "Вакансии и рефералы",
        text: "Обеспечим вас подходящими вакансиями и найдем рефералов.",
      },
    ]
  },
  talkitout_page: {
    backgroundImage: outcome5,
    outcome: [
      {
        title: "Эмоциональную разрядку",
        text: "Сможете выговориться и освободиться от накопившихся эмоций и это позволит снять стресс и напряжение.",
      },
      {
        title: "Анализ текущей ситуации",
        text: "Эксперт поможет вам понять, что именно вызывает затруднения и где находятся основные проблемные точки.",
      },
      {
        title: "Пути решения",
        text: "Совместно с экспертом вы наметите пути решения возникших проблем и создадите план действий.",
      },
    ]
  },
  it_hiring_page: {
    backgroundImage: outcome6,
    outcome: [
      {
        title: "Быстрое закрытие позиции",
        text: "Только тех кандидатов, которые на 90% подходят под профиль позиции.",
      },
      {
        title: "Высокую экспертизу ИТ найма",
        text: "Мы всегда подсказываем клиентам как выгоднее выстроить процессы ИТ подбора, не теряя качества.",
      },
      {
        title: "Выгодное закрытие вакансий",
        text: "Мы работаем по пакетной системе закрытия вакансий, которая позволит вам сэкономить бюджет.",
      },
    ]
  },
  it_training_page: {
    backgroundImage: outcome7,
    outcome: [
      {
        title: "Профессию в ИТ индустрии",
        text: "Авторская методика, позволяющая трудоустроиться уже внутри обучения.",
      },
      {
        title: "Коммерческий опыт работы как ИТ Рекрутер",
        text: "Единственный курс по ИТ подбору, который ориентирован на трудоустройство студентов.",
      },
      {
        title: "Первую работу в ИТ индустрии",
        text: "Единственный курс по ИТ подбору, который ориентирован на трудоустройство студентов."
      }
    ]
  },
  linkedin_boost_page: {
    backgroundImage: outcome8,
    outcome: [
      {
        title: "Оформленный LinkedIn‑профиль",
        text: "Профессионально оформленный LinkedIn‑профиль с чётким позиционированием.",
      },
      {
        title: "Рост",
        text: "Целевую аудиторию в своих контактах, рост просмотров профиля и входящих запросов.",
      },
      {
        title: "Рабочий инструмент",
        text: "LinkedIn как рабочий инструмент, а не «мертвую» соцсеть.",
      },
    ]
  },
  career_audit_page: {
    backgroundImage: outcome9,
    outcome: [
      {
        title: "Честная внешняя оценка",
        text: "Узнаете свой реальный уровень и грейд — объективными глазами рынка",
      },
      {
        title: "Понимание, как вас видят",
        text: "Что считывают рекрутеры и нанимающие менеджеры на первых минутах разговора",
      },
      {
        title: "Конкретный план действий",
        text: "Точки роста и чёткие рекомендации — что закрыть, что усилить, куда двигаться",
      },
      {
        title: "Прогноз по поиску",
        text: "Реалистичная зарплатная вилка, сроки и позиции, на которые стоит ориентироваться",
      },
      {
        title: "Письменный отчёт",
        text: "Остаётся у вас — можно возвращаться и сверяться в процессе поиска",
      },
    ]
  }
}
